<template>
  <div :class="['container', _isMobile() ? 'mobile' : '']">
    <a-card :bordered="false">
      <!-- <a-form>
        <a-form-item label="活动界次" :labelCol="{xs: { span: 8 },sm: { span: 2 }}" :wrapperCol="{xs: { span: 16 },sm: { span: 22 }}">
          <j-dict-select-tag
            :defaultShowAll="true"
            type="radioButton"
            v-model="queryParam.eventId"
            @change="eventChange"
            :trigger-change="true"
            dictCode="event_orders"
          />
        </a-form-item>
        <a-form-item label="排序方式" :labelCol="{xs: { span: 8 },sm: { span: 2 }}" :wrapperCol="{xs: { span: 16 },sm: { span: 22 }}">
          <a-radio-group button-style="solid" v-model="queryParam.orderBy" @change="getList">
            <a-radio-button value="time">
              最近更新
            </a-radio-button>
            <a-radio-button value="view">
              播放最多
            </a-radio-button>
            <a-radio-button value="like">
              推荐最多
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-form> -->
      <a-breadcrumb>
        <!-- <a-breadcrumb-item><a href="/">首页</a></a-breadcrumb-item> -->
        <a-breadcrumb-item><a href="/courseHome">课程首页</a></a-breadcrumb-item>
        <a-breadcrumb-item>课程列表</a-breadcrumb-item>
      </a-breadcrumb>
      <a-divider />
      <a-skeleton v-if="loading" />
      <a-list
        :grid="{ gutter: _isMobile() ? 12 : 24, lg: 4, md: 3, sm: 2, xs: 1 }"
        :dataSource="dataSource"
        :pagination="pagination"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card style="height:250px;" :bordered="false" @click="toDetail(item)">
            <div class="img-zoom">
              <img class="cover" :src="item.courseCover_url" alt="" />
            </div>
            <h3 class="title">{{ item.courseName }}</h3>
          </a-card>
        </a-list-item>
      </a-list>
    </a-card>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { getAction } from "@/api/manage";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import { mixinDevice } from "@/utils/mixin.js";
import "@/assets/less/animation.css";

export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag,
  },
  data() {
    return {
      dataSource: [],
      pagination: {
        onChange: this.pageChange,
        current: 1,
        pageSize: this._isMobile() ? 8 : 12,
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条";
        },
        total: 0,
      },
      loading: true,
      productType: "",
      tenantConfig: {},
      queryParam: {
        column: 'orderNum,createTime',
        order: 'desc',
        courseType: null,
        pageSize: 12,
        cmsStatus: 1,
        eventId: ''
      },
    };
  },
  created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (this.$route.query.type) {
      this.queryParam.courseType = this.$route.query.type
    }
    this.getList();
  },
  mounted() {},
  methods: {
    pageChange(page, pageSize) {
      this.dataSource = [];
      this.pagination.current = page;
      this.pagination.pageSize = pageSize;
      this.queryParam.pageNo = this.pagination.current;
      this.getList();
    },
    getList() {
      this.loading = true;
      this.dataSource = [];
      getAction("/teaching/teachingCourse/showCourse", this.queryParam).then((res) => {
        console.log(res);
        if (res.success) {
          this.pagination.total = res.result.total;
          this.dataSource = res.result.records;
        }
        this.loading = false;
      });
    },
    toDetail(item) {
        let route = this.$router.resolve({
        path: "/course/detail",
        query: {
          id: item.id,
        },
      });
      window.open(route.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.img-zoom {
  width: 100%;
  // height: 170px;
  border-radius: 4px;
  box-shadow: rgb(179, 179, 179) 0px 0px 5px;
  img {
    width: 100%;
    height: 100%;
  }
}
.title {
  margin-top: 5px;
}
.title:hover {
  color: #1890ff;
}
.search-card {
  /deep/.ant-card-body {
    padding: 20px;
  }
}
/deep/.ant-list-item {
  cursor: pointer;
  .ant-card-body {
    padding: 0;
  }
}
.mobile {
  .cover {
    height: 100px !important;
  }
}
</style>